<template>
  <div class="container-fluid footer">
    <div class="row text-center">
      <div class="col-xs-12 title-text  xs-pb-50">
        Learn Smarter, Organize Notes, Remember Everything. Get Started With Us, <strong>For Free!</strong>
      </div>
    </div>
    <div class="row text-center">
      <div class="col-xs-12 xs-pb-50">
        <router-link :to="{name: 'signup'}" class="btn-pub btn-pub-default">Sign Up For Free</router-link>  
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-4 xs-mb-30">
        <span>Follow Us</span>
        <div class="social-links">
          <a href="https://facebook.com" target="_blank"><img src="/static/img/icons/facebook2.png" /></a>
          <a href="https://twitter.com" target="_blank"><img src="/static/img/icons/twitter2.png" /></a>
          <a href="https://instagram.com" target="_blank"><img src="/static/img/icons/instagram2.png" /></a>
          <a href="https://youtube.com" target="_blank"><img src="/static/img/icons/youtube2.png" /></a>
          <a href="https://linkedin.com" target="_blank"><img src="/static/img/icons/linkedin2.png" /></a>
        </div>
      </div>
      <div class="col-xs-12 col-md-4 text-center xs-mb-30 ">
        <span>We'd love to hear from you</span><br />
        <div class="footer-nav xs-mt-20">
          <router-link :to="{name: 'contact-us'}">Contact us</router-link> |
          <router-link :to="{name: 'feedback-form'}">Feedback form</router-link>
        </div>
      </div>
      <div class="col-xs-12 col-md-4 text-right xs-mb-30">
        <span>Join our mailing list</span>
        <div class="clearfix"></div>
        <SubscribeForm class="sub"></SubscribeForm>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="footer-nav">
          <a target="_blank" href="https://www.websitepolicies.com/policies/view/ppLviGYs">Terms &amp; conditions</a> |
          <!--<router-link :to="{name: 'privacy-policy'}">Privacy policy</router-link>-->
          <a href="https://www.iubenda.com/privacy-policy/71921731/legal" target="_blank">Privacy Policy</a>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 text-right">
        &copy; Copyright CLEX {{year}}
      </div>
    </div>
  </div>

</template>


<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
  import SubscribeForm from '../newsletter/SubscribeForm'

export default {
    components: {
      SubscribeForm,
    },
    data() {
      return {
        year: new Date().getFullYear(),
      }
    },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .footer { background-image: linear-gradient(#1e74fe, #5495fd); color: #FFFFFF; padding: 100px 50px; font-size: 18px; }

  .title-text {font-size:2rem;}

  .footer-nav a { color: #FFFFFF; margin: 0px 10px; }
  .footer-nav a:first-child { margin-left: 0px; }
  .footer-nav a:last-child { margin-right: 0px; }
  .footer-nav a:hover {text-decoration:underline;}

  .social-links {margin-top:6px;}
  .social-links a {display: inline-block; margin-right: 20px;}
  .social-links a:last-child {margin:0px;}
  .social-links a img { width: 40px; }

  .sub { float: right; }

  @media (max-width: 992px) {
    .footer {padding: 50px 20px; font-size: 18px; }
    .footer, .text-right, .text-left { text-align: center; }
    .social-links a {margin-right:14px;}
  }
</style>



// WEBPACK FOOTER //
// FooterNav.vue?78bc217e